import { SignalingStateType } from "./types";
import { createReducer } from "@reduxjs/toolkit";
import { setPartnerStream, setSignalingSessionHold, setSignalingStatus, setUserStream, stopPartnerStream, stopUserStream } from "./actions";

const initialState: SignalingStateType = {
  status: undefined,
  userStream: undefined,
  partnerStream: undefined,
  sessionHold: false,
};

export const signalingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setSignalingStatus, (state, action) => {
      state.status = action.payload;
    })
    .addCase(setUserStream, (state, action) => {
      state.userStream = action.payload;
    })
    .addCase(setPartnerStream, (state, action) => {
      state.partnerStream = action.payload;
    })
    .addCase(stopPartnerStream, (state, action) => {
      state.partnerStream?.getTracks().forEach((track) => track.stop());
      state.partnerStream = undefined;
    })
    .addCase(stopUserStream, (state, action) => {
      state.userStream?.getTracks().forEach((track) => track.stop());
      state.userStream = undefined;
    })
    .addCase(setSignalingSessionHold, (state, action) => {
      state.sessionHold = action.payload;
    });
});
